import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const useLanguageStyles = () => {
  const { language } = useLanguage();

  useEffect(() => {
    // NOTE:
    // CRA 프로덕션 빌드에는 /src 경로가 존재하지 않아서
    // /src/styles/... 를 동적으로 로드하면 MIME 오류가 발생합니다.
    // 언어별 CSS는 번들(import)로 포함하고, 여기서는 body 클래스만 토글합니다.

    // body에 언어 클래스 추가
    document.body.className = document.body.className.replace(/\b(ko|en)\b/g, '');
    document.body.classList.add(language);
  }, [language]);
};
